import React from 'react';
import ModalWrapper from '../ModalWrapper';

import ModalFinanciadoBody from './ModalFinanciadoBody';


const ModalFinanciado = ({isOpen, simulateDataDefault, onCloseModal}) => (
    <ModalWrapper isOpen={isOpen} cssClass="modal-financiado">
        <ModalFinanciadoBody simulateDataDefault={simulateDataDefault} onCloseModal={onCloseModal} />
    </ModalWrapper>
);

export default ModalFinanciado;